import { FileListItem } from '@shared/model/file';
import { DOCUMENTS_LIST } from '@entities/file/config/documents-constants';

export const getFileUrlByCode = (list: FileListItem[], code: DOCUMENTS_LIST) =>
    list?.find((item) => item?.code === code)?.url || '';
